// extracted by mini-css-extract-plugin
export default {"close":"success-modal_close__vYJ5R","successText":"success-modal_successText__sk+w0","closeButin":"success-modal_closeButin__bGjKd"};